import React, { useCallback, useEffect, useState } from "react";

import { getUserFarms } from "services";

import { useNavigate } from "utils";

import { AdminTable, Col, Row, Typography } from "components";

export const RelatedFarmsTab = ({ currentFarm }) => {
  const [farms, setFarms] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const loadUserFarms = useCallback(() => {
    setLoading(true);
    getUserFarms({
      userId: currentFarm.user.id,
    })
      .then((res) => {
        setFarms(res);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [currentFarm.user.id]);

  useEffect(() => {
    loadUserFarms();
  }, [loadUserFarms]);

  const handleClick = (farm) => {
    navigate(`/farm/${farm.id}`);
    window.location.reload();
  };

  const relatedFarms = farms.map((farm) => farm.farm).filter((farm) => farm.id !== currentFarm.id);

  return !loading ? (
    <Row>
      <Col>
        {relatedFarms.length ? (
          <AdminTable
            dataSource={relatedFarms}
            config={{
              exclude: [
                "id",
                "code",
                "createdAt",
                "disabledAt",
                "maxHectares",
                "partnerId",
                "updatedAt",
                "verifiedDate",
                "verifiedReason",
                "zip",
                "verifiedByAdminUser",
                "test",
                "reviewerId",
                "dealId",
              ],
              actions: [
                {
                  icon: "klim/farm",
                  func: (farm) => handleClick(farm),
                  record: "id",
                  tooltip: "View this farm",
                },
              ],
            }}
          />
        ) : (
          <Typography variant="paragraph-m">This user has only 1 farm</Typography>
        )}
      </Col>
    </Row>
  ) : null;
};
